<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>COMMUNICATION
            <mat-icon class="m-l-10 m-b-5 pointer" 
                appWhatsappDialogTrigger 
                [patientId]="patient?.id" 
                [patient]="patient"
                matTooltip="Open WhatsApp chat" 
                svgIcon="whatsapp">
            </mat-icon>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-info">
        <ng-container *ngIf="communicationData; else listLoading">
            <ng-container *ngIf="communicationData.length; else noResults">
                <ng-container *ngFor="let group of communicationData">
                    <div class="list-header">
                        {{ group.date | date: 'longDate' }}
                    </div>
                    <mat-list class="full-width">
                        <ng-container *ngFor="let item of group.items">
                            <mat-list-item class="auto-height">
                                <div class="panel-item">
                                    <div class="panel-details">

                                        <div matLine class="panel-title">
                                            <span>{{ item.communicationType }}</span>
                                        </div>

                                        <div matLine class="panel-information-details">
                                            Sent To: {{item.name}}, <span *ngIf="item.email">Email:
                                                <a href="mailto:{{item.email}}" target="_blank" rel="noopener">{{item.email}}</a></span><span *ngIf="item.mobileNumber">Mobile Number:
                                                <a href="tel:{{item.mobileNumber}}" (click)="dialPhone($event, item.mobileNumber)" target="_blank" rel="noopener">{{item.mobileNumber}}</a></span><span *ngIf="item.speciality">,
                                                Speciality: {{item.speciality}}</span>
                                        </div>

                                        <!--   <div matLine class="panel-information-details preserve-line-breaks"
                                            [innerText]="item.content">
                                        </div> -->

                                        <!-- Removed file gallery - images are no longer created/stored -->
                                        <!-- <app-file-gallery [fileObjects]="item.media"
                                            [deleteEnabled]="false"></app-file-gallery> -->

                                        <div *ngIf="item.hasProcessingPdf" class="processing-indicator">
                                            <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
                                            <span class="processing-message">Processing documents...</span>
                                        </div>

                                        <div matLine class="panel-footer">
                                            <div>Sent By: {{ item.createdBy }} at {{item.createdAt | date:
                                                'HH:mm'}}</div>
                                        </div>
                                    </div>
                                    <div class="view-icon">
                                        <button mat-icon-button matTooltip="View communication content"
                                            (click)="openCommunicationDialog(item, $event)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="sentEmails?.length">
            <div class="list-header">Sent emails</div>
            <mat-list class="full-width">
                <mat-list-item *ngFor="let email of sentEmails" class="auto-height">
                    <div class="panel-item">
                        <div class="panel-details">
                            <div matLine class="panel-title">{{ email.subject }}</div>
                            <div matLine class="panel-footer">
                                <div>{{ email.createdAt | date: 'medium' }}</div>
                            </div>
                        </div>
                        <div *ngIf="canWithdrawFromApp(email)" class="view-icon">
                            <button mat-icon-button matTooltip="Remove from the patient's app inbox and timeline"
                                (click)="withdrawMailFromApp(email, $event)">
                                <mat-icon>phonelink_erase</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="email.patientAppWithdrawnAt" class="panel-footer">
                            <span>Removed from the patient app</span>
                        </div>
                    </div>
                </mat-list-item>
            </mat-list>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>